// @generated by TypeGen from LogbookModel/Generator/GeneratorRunStatus.swift - DO NOT EDIT

export enum IGeneratorRawState {
  preheating = 0,
  startDelay = 1,
  cranking = 2,
  starterCooling = 3,
  warmingUp = 4,
  coolingDown = 5,
  spinningUp = 6,
  shutdownBypass = 7,
  stopping = 8,
  running = 9,
  stopped = 10,
  crankDelay = 11,
}

export enum IGeneratorRunState {
  off = "off",
  starting = "starting",
  running = "running",
  stopping = "stopping",
}

export enum IGeneratorStatus {
  off = 0,
  starting = 1,
  running = 2,
  stopping = 3,
}
